<template>
  <div
    v-if="shouldShow"
    :class="[
      { '--overlay': overlay },
      'countdown p-absolute d-flex align-items-center justify-content-center'
    ]"
  >
    <template v-if="isLoading">
      <v-loader white />
    </template>
    <template v-else>
      <span class=" text-small font-weight-semi-bold countdown__time">
        <template v-if="forceNow || isNow">
          Now
        </template>
        <template v-else-if="shouldCountdown && countdownTimer">
          in {{ countdownTimer.humanTime }}
        </template>
        <template v-else-if="isToday || isTomorrow">
          {{ isToday ? "Today" : "Tomorrow" }} -
          {{ toTime(startsAt, "h:mm A") }}
        </template>
        <template v-else>
          {{ timeAgo(startsAt) }}
        </template>
      </span>
    </template>
  </div>
</template>

<script>
import {
  timeAgo,
  isFuture,
  isPast,
  isWithin,
  toTime,
  isSameDay,
  secondsUntil
} from "@/lib/date-utils"
import Timer, { COUNT_DIRECTIONS, TIMER_EVENTS, FORMATS } from "@/lib/timer"

export default {
  props: {
    isLoading: { type: Boolean, default: false },
    overlay: { type: Boolean, default: false },
    horizontal: { type: Boolean, default: false },
    startsAt: { type: String, default: "" },
    endsAt: { type: String, default: "" }
  },

  data() {
    return {
      forceNow: false,
      countdownTimer: null
    }
  },

  computed: {
    shouldShow() {
      return isWithin(this.startsAt, 1, "day")
    },

    isToday() {
      return isFuture(this.startsAt) && isSameDay(this.startsAt)
    },

    isTomorrow() {
      return (
        isFuture(this.startsAt) &&
        isWithin(this.startsAt, 1, "day") &&
        !this.isToday
      )
    },

    isNow() {
      return isPast(this.startsAt) && isFuture(this.endsAt)
    },

    shouldCountdown() {
      return isFuture(this.startsAt) && isWithin(this.startsAt, 3, "hour")
    }
  },

  methods: {
    timeAgo,
    toTime
  },

  mounted() {
    if (this.shouldCountdown) {
      this.countdownTimer = new Timer({
        seconds: secondsUntil(this.startsAt),
        countDirection: COUNT_DIRECTIONS.DOWN,
        format: FORMATS.READABLE_SHORT
      })
      this.countdownTimer.on(TIMER_EVENTS.FINISHED, () => {
        this.forceNow = true
      })
      this.countdownTimer.start()
    }
  },

  beforeDestroy() {
    if (this.countdownTimer) this.countdownTimer.reset()
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';

@import "@/assets/styles/variables";

.countdown {
  background-color: rgba($color-rgb--grey-90, 0.24);
  backdrop-filter: blur(4px);
  color: $color-ui--white;
  right: $size--2;
  bottom: 4.5%;
  margin-top: -#{math.div($size--8, 2)};
  height: $size--8;
  width: $size--8;
  border-radius: $size--10;
  width: auto;
  padding: 0 $size--2;
  z-index: 1;
  max-width: 100%;
  max-width: calc(100% - #{$size--2 * 2});

  .v-loader {
    height: $size--4;
    width: $size--4;
  }

  &.--overlay {
    top: $size--6;
    bottom: auto;
  }
}

.countdown__time {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.access-lock__time {
  margin: 0 $size--1 2px;
}
</style>
